import {Component, ViewChild} from '@angular/core';
import {Content, NavController, NavParams, PopoverController, ViewController} from 'ionic-angular';
import {Observable} from "rxjs/Observable";
import {LoadingServiceProvider} from "../../providers/loading-service/loading-service";
import {Subscription} from "rxjs/Subscription";
import {AutoUnsubscribe} from "ngx-auto-unsubscribe";
import {GlobalProvider} from "../../providers/global/global";
import {TemplateService} from "../../store/template/template.service";
import {AuditEntity} from "../../store/audit/audit.entity";
import {ContactEntity} from "../../store/contact/contact.entity";
import {AuditService} from "../../store/audit/audit.service";
import {ProtocolService} from "../../store/protocol/protocol.service";
import {ContactService} from "../../store/contact/contact.service";

/**
 * Generated class for the PruefungProtokollePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@AutoUnsubscribe()
// @IonicPage({
//   segment: 'protokolle/:protokollId'
// })
@Component({
  selector: 'page-pruefung-protokolle',
  templateUrl: 'pruefung-protokolle.html',
})
export class PruefungProtokollePage {

  @ViewChild(Content) content: Content;

  public protokolle: Observable<Array<any>>;
  public pruefung: AuditEntity;
  public isOwner: boolean = false;
  public selectedProtokollId: string = null;

  private _customer: ContactEntity;
  private _standortSubscriber: Subscription;
  private _protokollProvider: Subscription;
  private _contactSubscripton: Subscription;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              // private protokollProvider: ProtokollProvider,
              // private standortProvider: StandortProvider,
              // private dataProvider: DataProvider,
              public protocolService: ProtocolService,
              private auditService: AuditService,
              private contactService: ContactService,
              private popoverCtrl: PopoverController,
              private loadingProvider: LoadingServiceProvider,
              private globalProvider: GlobalProvider) {

    this.pruefung = this.navParams.get('pruefung');
    this.isOwner = this.pruefung.ownerId === this.globalProvider.user.uuid;

    this._contactSubscripton = this.contactService.getById(this.pruefung.customerId)
      .subscribe((customer) => {
        this._customer = customer;
      });
    let selectProtokollId = this.navParams.get('protokollId');
    if(selectProtokollId){
      this.selectedProtokollId = selectProtokollId;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PruefungProtokollePage');
  }

  ionViewWillLeave(){
    this._contactSubscripton.unsubscribe();
  }

  public selectProtokoll(protokollId: string): void {
    this.selectedProtokollId = protokollId;
  }

  public new(ev: UIEvent): void {
    let _popover = this.popoverCtrl.create(PopoverPage);
    _popover.onDidDismiss((template) => {
      if(template){
        let _newProtokoll = JSON.parse(JSON.stringify(template));
        _newProtokoll.customerId = this._customer._id;
        _newProtokoll.docType = "protocol";
        _newProtokoll.docName = "Protokoll";
        delete _newProtokoll._id;
        delete _newProtokoll._rev;

        this.protocolService.add(_newProtokoll, false)
          .then((_newProtokoll) => {
            this.pruefung.protokolle.push(_newProtokoll._id);
            this.auditService.set(this.pruefung, false);
            this.selectedProtokollId = _newProtokoll._id;
            this.loadingProvider.dismiss();
          });
      }
    })
    _popover.present({
      ev: ev
    });
    // this.selectedProtokoll = this.protokollProvider.new(this._customer.id);
  }

  public protokollDeleted(protokoll: any): void {
    // this.protokolle = this.protokolle.filter((item) => {
    //   return item.id !== protokollId;
    // })
    // this.selectedProtokoll = null;
    this.selectedProtokollId = null;
    this.pruefung.protokolle = this.pruefung.protokolle.filter((_PruefungProtokollId) => {
      return _PruefungProtokollId !== protokoll._id;
    })
    this.auditService.set(this.pruefung, false);
    // this.dataProvider.updateDocument(this.pruefung);
    // this.dataProvider.softDeleteDocument(protokoll);
    this.protocolService.remove(protokoll, false);

    this.content.scrollToTop(0);

  }


  public changeProtokollId(protokollId: string): void {
    this.selectedProtokollId = protokollId;
  }

  // If you work with AOT this method must be present, even if empty!
  // Otherwise 'ng build --prod' will optimize away any calls to ngOnDestroy,
  // even if the method is added by the @AutoUnsubscribe decorator
  ngOnDestroy() {
    // You can also do whatever you need here
  }

}

@Component({
  template: `
    <ion-list>
      <ion-list-header>Vorlage auswählen</ion-list-header>
      <button ion-item (click)="close(template)" *ngFor="let template of (templateService.getAll() | async)">{{template.title}}</button>
    </ion-list>
  `
})
export class PopoverPage {

  constructor(public viewCtrl: ViewController,
              public templateService: TemplateService,
              private loadingProvider: LoadingServiceProvider) {
  }

  close(template) {
    this.loadingProvider.present();
    this.viewCtrl.dismiss(template);
  }
}



// WEBPACK FOOTER //
// ./src/pages/pruefung-protokolle/pruefung-protokolle.ts